import Img from 'next/image';
import imgMasthead1 from './images/mastehead-1.png';
import imgMasthead2 from './images/mastehead-2.png';
import imgBarSr from './images/blue-bar-images-sr.png';
import imgBarQs from './images/blue-bar-images-qs.png';
import imgBarEx from './images/blue-bar-images-ex.png';
import imgCover from './images/cover-photo.jpg';
import ClientOnly from '@components/ClientOnly';

export default () => (
  <ClientOnly>
    <div id="page">
      <div id="main">
        <div id="whitebar">
          <div id="masthead-whitebar">
            <div id="masthead-inner">
              <Img src={imgMasthead1} alt="" />
            </div>
            <div id="masthead-inner">
              <Img src={imgMasthead2} alt="" />
            </div>
          </div>
        </div>

        <div id="bluebar">
          <div id="masthead-bluebar">
            <div id="masthead-innerbb1">
              <a href="/files/Koppers_CSR_2021_Full_Report.pdf" download>
                <Img src={imgBarSr} className="imagesize" />
              </a>
            </div>
            <div id="masthead-innerbb2">
              <a href="/files/Koppers_CSR_2021_Quick_Sheet.pdf" download>
                <Img src={imgBarQs} className="imagesize" />
              </a>
            </div>
            <div id="masthead-innerbb2">
              <a href="/files/Koppers-CSR-Data-Master-Sheet.xlsx" download>
                <Img src={imgBarEx} className="imagesize" />
              </a>
            </div>
          </div>
        </div>

        <div id="videoclip">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/AkiYK-d2K38"
            title="Koppers 2021 Sustainability Report"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            loading="eager"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <style jsx>
        {`
          #page {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
          }
          #main {
            background-image: url(${imgCover.src});
            background-size: cover;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
          #whitebar {
            background-color: #ffffff;
            opacity: 0.9;
            padding-left: 15px;
          }
          #bluebar {
            background-color: #006c86;
            opacity: 0.9;
            padding-left: 15px;
          }
          #videoclip {
            margin-left: auto;
            margin-right: auto;
            margin-top: 5%;
            width: 700px;
            height: 394px;
            background-color: #ffffff;
            padding-top: 10px;
            padding-right: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
          }
          #masthead-whitebar {
            margin-left: auto;
            margin-right: auto;
            width: 1000px;
            height: 130px;
            padding-top: 20px;
          }
          #masthead-bluebar {
            margin-left: auto;
            margin-right: auto;
            width: 1000px;
            height: 96px;
          }
          #masthead-inner {
            width: 50%;
            float: left;
          }
          #masthead-innerbb1 {
            width: 35%;
            float: left;
            padding-top: 2%;
            padding-bottom: 2%;
          }
          #masthead-innerbb2 {
            width: 29%;
            float: left;
            padding-top: 2%;
            padding-bottom: 2%;
          }
          #videoclip {
            margin-left: auto;
            margin-right: auto;
            margin-top: 5%;
            width: 700px;
            height: 394px;
            background-color: #ffffff;
            padding-top: 7px;
            padding-right: 7px;
            padding-bottom: 7px;
            padding-left: 7px;
          }
          .imagesize {
            height: 55px;
            width: auto;
          }
          @media screen and (max-width: 1000px) {
            #masthead-whitebar {
              width: 100%;
              height: 130px;
            }
            #masthead-bluebar {
              width: 100%;
              height: 90px;
            }
            .imagesize {
              height: 39px;
              width: auto;
            }
          }
          @media screen and (max-width: 600px) {
            #videoclip {
              margin-left: auto;
              margin-right: auto;
              margin-top: 5%;
              width: 320px;
              height: 180px;
              background-color: #ffffff;
              padding-top: 5px;
              padding-right: 5px;
              padding-bottom: 5px;
              padding-left: 5px;
            }
            #masthead-whitebar {
              height: auto;
            }
            #whitebar {
              padding-bottom: 5%;
            }
            #bluebar {
            }

            #masthead-bluebar {
              height: auto;
            }
            #masthead-inner {
              width: 100%;
              float: none;
            }
            #masthead-innerbb1 {
              width: 100%;
              float: none;
            }
            #masthead-innerbb2 {
              width: 100%;
              float: none;
            }
          }
        `}
      </style>
    </div>
  </ClientOnly>
);
